import React, { useEffect } from 'react';
import trackEvent from 'misc/trackEvent';
import FeedbackCriteriaInsights from './FeedbackCriteriaInsights';

const LearnerImpactContainer = () => {
  useEffect(() => {
    trackEvent('insights/learner_impact_tab_viewed');
  });
  return (
    <div>
      <FeedbackCriteriaInsights />
    </div>
  );
};

export default LearnerImpactContainer;
